<template>
    <div style="box-sizing: border-box;padding: 30px;">
        <div class="p1 flx alc jsb" v-if="resume != ''">
            <div class="flx alc jl">
                <img :src="$Localimg('word.png')" alt="">
                <div>
                    我的简历.{{filetype}}
                </div>
            </div>
            <div class="jr flx alc">
                <div class="bluebtn cursor" @click="downloadjl">
                    <img :src="$Localimg('ic6.png')" alt=""> 下载
                </div>
                <div class="bluebtn cursor" @click="ups = true" style="margin-left: 26px;">
                    <img :src="$Localimg('ic12.png')" alt=""> 上传新简历
                </div>
            </div>
        </div>
        
        <div class="p1 flx alc jsb" v-else>
            <div class="flx alc jl">
                <img :src="$Localimg('word.png')" alt="">
                <div>
                   暂无简历
                </div>
            </div>
            <div class="jr flx alc">
                <div class="bluebtn cursor" @click="ups = true" style="margin-left: 26px;">
                    <img :src="$Localimg('ic12.png')" alt=""> 上传简历
                </div>
            </div>
        </div>

        <div class="jtitle">
            已投简历:
        </div>
        <div class="recontent flx alc jsb">
            <div class="reItem flx alc jsb cursor" v-for="item,index in list" @click="toDetail(item)">
                <div class="reLeft">
                    <div class="rlt flx alc">
                        <div class="rname" v-text="item.name"></div>
                        <div class="rsalary" v-if="item.salary_mix > 0 && item.salary_max > 0" v-text="`${item.salary_mix}K ~ ${item.salary_max}K`"></div>
                        <div class="rsalary" v-else>面议</div>
                    </div>
                    <div class="rlv flx alc">
                        <div class="rlabel" v-text="item.exp_name"></div>
                        <div class="rlabel" v-text="item.eb_name"></div>
                    </div>
                    <div class="rlb flx alc">
                        <i class="el-icon-location" style="color: #555C70;"></i>
                        <span v-text="item.city_name"></span>
                        <span> · </span>
                        <span v-text="item.area_name"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="mask" v-if="ups == true">
            <div class="upjl">
                <div class="upsTitle flx alc jsb">
                    <span>上传简历</span>
                    <i class="el-icon-close" @click="ups = false"></i>
                </div>
                <el-upload class="upload-demo" style="width: 100%;" action="https://hrxsl.com/api/Common/oss_upload"
                    :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :headers="uploadHeaders"
                    :show-file-list="false">
                    <div class="upp">
                        <div class="upp1">
                            点击上传文件，快速上传
                        </div>
                        <div class="upp2">
                            请上传DOC、DOCX、PDF格式的中文简历，大小不超过20M
                        </div>
                        <div class="flx alc jsc">
                            <el-button style="margin: 55px auto 0;" size="small" type="primary">上传文件</el-button>
                        </div>
                    </div>
                </el-upload>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        userInfo,
        getmyjl,
        edituser 
    } from "@/api/index.js"
    export default {
        name: 'userinfo',
        data() {
            return {
                filetype: '',
                resume: "",
                list: [],
                ups: false,
                uploadHeaders: {
                    token: localStorage.getItem('token'),
                    source: "pc"
                },
            }
        },
        mounted() {
            let that = this
            that.getinfo()
        },
        methods: {
            toDetail(e){
                let that = this 
                that.$router.push({
                    path: '/RecruitmentDetail', // 写路由path
                    query: {
                        id:e.job_id
                    }
                })
            },
            downloadjl() {
                window.location.href = this.$imageUrl + this.resume
            },
            beforeAvatarUpload(file) {
                console.log(file.type)
                // 1. 允许的图片格式
                const allowType = ['doc', 'pdf', 'docx']
                // 2. 最大8MB
                const maxSize = 20 * 1024 * 1024
                 const suffix = file.name.split('.').pop().toLowerCase()
                // 校验格式
                if (!allowType.includes(suffix)) {
                    this.$message.error('仅支持 doc 和pdf 格式文件！')
                    return false
                }
            
                // 校验大小
                if (file.size > maxSize) {
                    this.$message.error('文件不能大于20MB！')
                    return false
                }
            
                // 校验通过，允许上传
                return true
            },
            getFileSuffix(filename) {
                // 匹配最后一个 . 后面的字符
                const match = filename.match(/\.([^.]+)$/);
                // 有后缀返回小写后缀，无则返回空
                return match ? match[1].toLowerCase() : '';
            },
            handleAvatarSuccess(e) {
                let that = this 
                console.log(e)
                if(e.code == 1){
                    let data = {}
                    data.resume = e.data.url
                    edituser(data).then((rest) => {
                        if (rest.code == 1) {
                            that.$message.success(rest.msg)
                             that.getinfo()
                            that.ups = false
                        } else {
                            that.$message.error(rest.msg)
                        }
                    })
                }else{
                     that.$message.error(e.msg)
                }
            },
            getinfo() {
                let that = this
                userInfo().then((res) => {
                    if (res.code == 1) {
                        that.resume = res.data.resume
                        that.filetype = that.getFileSuffix(res.data.resume)
                    }

                })
                getmyjl().then((res) => {
                    console.log(111111, res)
                    if (res.code == 1) {
                        that.list = res.data
                    }
                })
            }
        }
    }
</script>

<style scoped>
    
    .maskContent {
        width: 274px;
        height: 183px;
        background: url('https://hrxsl.com/pcImages/jlbk.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        box-sizing: border-box;
        padding: 20px;
    }
    
    .mask {
        width: 100vw;
        height: 100vh;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1998 !important;
        position: fixed;
        left: 0;
        top: 0;
    }
    .upp2 {
        font-weight: 400;
        font-size: 13px;
        color: #999999;
        text-align: center;
    }

    .cbitem {
        font-size: 18px;
    }

    .upp1 {
        font-weight: 600;
        font-size: 16px;
        color: #000000;
        text-align: center;
        margin-bottom: 10px;
    }

    .upp {
        width: 542px;
        height: 241px;
        background: #F3F6FF;
        border-radius: 8px 8px 8px 8px;
        box-sizing: border-box;
        padding-top: 50px;
        margin-top: 14px;
    }

    .upsTitle span {
        font-weight: 600;
        font-size: 18px;
        color: #000000;
    }

    .upjl {
        width: 582px;
        height: 330px;
        background: url('https://hrxsl.com/pcImages/jlbk.png') no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        box-sizing: border-box;
        padding: 20px;
    }

    .recontent {
        flex-wrap: wrap;
    }

    .jtitle {
        margin: 30px 0;
        font-weight: 600;
        font-size: 14px;
        color: #000000;
        text-align: left
    }

    .jr {
        font-size: 14px;
        color: #000000;
    }

    .p1 {
        width: 100%;
        height: 70px;
        border-radius: 5px;
        border: 1px solid #E8E8E8;
        box-sizing: border-box;
        padding: 20px;
    }

    .jl img {
        width: 30px;
        height: 30px;
        margin-right: 8px;
    }

    .codename {
        font-size: 12px;
        color: #666666;
        text-align: center;
    }

    .codeImg {
        width: 84px;
        height: 84px;
    }

    .codeImg img {
        width: 100%;
        height: 100%;
    }

    .codeItem {
        background: #fff;
        box-sizing: border-box;
        padding: 16px;
    }

    .advItem {
        width: 100%;
        height: 138px;
        margin-bottom: 20px;
        cursor: pointer;
        object-fit: cover;
    }

    .advItem img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
    }

    .advs {
        width: 244px;
        box-sizing: border-box;
        padding-top: 17px;
    }

    .reRight {
        width: 88px;
        height: 36px;
        background: #007AFF;
        border-radius: 3px;
        text-align: center;
        line-height: 36px;
        font-size: 14px;
        color: #FFFFFF;
        cursor: pointer;
    }

    .comTop img {
        width: 22px;
        height: 22px;
        margin-right: 8px;
    }

    .comTop div {
        font-size: 16px;
        color: #222222;
    }

    .rlb {
        font-size: 14px;
        color: #555C70;
    }

    .rlabel {
        height: 23px;
        background: #F5F7FA;
        border-radius: 2px;
        font-size: 12px;
        color: #555C70;
        line-height: 23px;
        padding: 0 9px;
        margin: 12px 0;
        margin-right: 10px;
    }

    .rsalary {
        font-weight: 500;
        font-size: 18px;
        color: #007AFF;
    }

    .rname {
        font-weight: 600;
        font-size: 18px;
        color: #000000;
        margin-right: 14px;
    }

    .reLeft {
        width: 440px;

    }

    .reItem {
        background: #fff;
        border-radius: 10px;
        width: 454px;
        box-sizing: border-box;
        padding: 20px;
        margin-top: 16px;
        border: 1px solid #d9d9d9
    }

    .reItemns {
        width: 1194px;

    }

    .active {
        background: #007AFF !important;
        color: #fff !important;
    }

    .taavb {
        width: 100%;
        height: 42px;
        background: #ffffff;
        border-bottom: 4px solid #007AFF;
    }

    .taItem {
        width: 145px;
        height: 42px;
        text-align: center;
        line-height: 44px;
        cursor: pointer;
    }

    .clears {
        font-size: 14px;
        color: #999999;
    }

    .sceencataes {
        width: 100%;
        background: #fff;
        height: 48px;
        display: flex;
        align-items: center;
    }

    .scinner {
        width: 1460px;
        margin: 0 auto;
    }

    .recocon {
        width: 1460px;
        margin: 40px auto 0;
    }
</style>